import * as React from "react";
import type { SVGProps } from "react";
const SvgJet2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#ee3123"
      d="m36.918 14.4 3.121 7.423-1.434-.042-5.358-7.38s-1.434-.042-1.982-.042c-.254 0-.549 0-.929-.084a275 275 0 0 1-1.982 11.07c-1.646 8.26-1.519 14.13-8.69 14.13-2.279 0-4.43-1.048-4.43-2.725 0-3.02.464-8.26.464-8.26l-12.15-.042S3 33.479 3 38.846C3 43.71 8.358 50.042 18.904 50c8.058-.042 13.415-1.887 18.056-8.47 2.32-3.27 3.459-11.07 5.273-19.582.506-2.474 1.055-4.99 1.56-7.337l-.463-.546zM40.588.02c-2.363.042-5.19.503-6.75 2.39-1.603 1.887-2.447 5.535-2.869 7.799-.084.587-.21 1.3-.337 2.138.253-.042.464-.042.633-.042.548 0 1.982-.042 1.982-.042l5.358-7.38 1.434-.041-3.122 7.38 6.455.377 1.181-1.384L47 .02s-4.05-.042-6.412 0"
    />
  </svg>
);
export default SvgJet2;
